<template>
  <section class="leadership-home">
    <header class="leadership-intro">
      <span class="intro-icon"><v-icon>mdi-account-tie-outline</v-icon></span>
      <div>
        <div class="eyebrow">Exzellente Führung entsteht im Austausch</div>
        <h2>Leadership</h2>
        <p>
          Teile Wissen, entwickle deine Führungskompetenz weiter und nutze individuelles Sparring für aktuelle Herausforderungen.
        </p>
      </div>
    </header>

    <div class="leadership-grid">
      <article v-for="area in areas" :key="area.path" class="leadership-card" :style="{ '--accent': area.color, '--accent-bg': area.background }">
        <div class="card-heading">
          <span class="card-icon"><v-icon>{{ area.icon }}</v-icon></span>
          <span v-if="area.badge" class="card-badge">{{ area.badge }}</span>
        </div>
        <div class="card-copy">
          <span>{{ area.eyebrow }}</span>
          <h3>{{ area.title }}</h3>
          <p>{{ area.description }}</p>
        </div>
        <ul>
          <li v-for="item in area.features" :key="item"><v-icon>mdi-check-circle-outline</v-icon>{{ item }}</li>
        </ul>
        <v-btn block depressed class="area-action" :to="area.path">
          {{ area.action }}
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "LeadershipHome",
  data() {
    return {
      areas: [
        {
          title: "Leadership Connect",
          eyebrow: "Gemeinsam führen",
          description: "Dein geschützter Raum für Austausch, Fragen und aktuelle Informationen aus der Academy.",
          icon: "mdi-forum-outline",
          action: "Connect öffnen",
          path: "/akademie/leadership/connect",
          color: "#7ee5a6",
          background: "rgba(0, 150, 64, 0.13)",
          badge: "Live Austausch",
          features: ["Geschlossener Leadership-Chat", "Tools und Termine im Blick", "Von Erfahrungen anderer lernen"],
        },
        {
          title: "Leadership Coaching",
          eyebrow: "Schritt für Schritt",
          description: "Praxisnahe Tools, Lehrvideos und Evaluationen für eine wirksame und erfolgreiche Führung.",
          icon: "mdi-school-outline",
          action: "Coaching starten",
          path: "/akademie/leadership/coaching",
          color: "#93c5fd",
          background: "rgba(59, 130, 246, 0.13)",
          features: ["Nach Themen sortierte Tools", "Lehrvideos im eigenen Tempo", "Quiz oder Video-Evaluation"],
        },
        {
          title: "Leadership Coaching 1:1",
          eyebrow: "Individuelles Sparring",
          description: "Buche deine Personal Coaching Session oder frage für komplexere Themen eine Extra-Session an.",
          icon: "mdi-account-supervisor-circle-outline",
          action: "Termin finden",
          path: "/akademie/leadership/coaching-1to1",
          color: "#fcd34d",
          background: "rgba(245, 158, 11, 0.13)",
          features: ["Freie Termine direkt buchen", "Automatischer Microsoft Teams-Link", "Extra-Session für längere Themen"],
        },
        {
          title: "Leadership Docs",
          eyebrow: "Aktuelles Wissen",
          description: "Verbindliche Leitfäden und aktuelle Dokumente für Führungskräfte zentral und geschützt abrufen.",
          icon: "mdi-folder-key-outline",
          action: "Dokumente öffnen",
          path: "/akademie/leadership/docs",
          color: "#f9a8d4",
          background: "rgba(236, 72, 153, 0.13)",
          features: ["Immer die aktuelle Version", "Nach Themen übersichtlich sortiert", "Geschützt für Führungskräfte"],
        },
        {
          title: "Leadership Creative",
          eyebrow: "Ideen für Führung",
          description: "Dein geschützter Raum für kreative Führungsimpulse, Best Practices und den Austausch unter Führungskräften.",
          icon: "mdi-lightbulb-group-outline",
          action: "Creative öffnen",
          path: "/akademie/leadership/creative",
          color: "#c4b5fd",
          background: "rgba(139, 92, 246, 0.13)",
          badge: "Nach Modulabschluss",
          features: ["Passende Themen schrittweise freischalten", "Ideen und Erfahrungen sicher teilen", "Gemeinsam Lösungen weiterentwickeln"],
        },
      ],
    }
  },
}
</script>

<style scoped>
.leadership-home {
  --border: rgba(255, 255, 255, 0.1);
  --muted: #a3a3a8;
  color: #f4f4f5;
  font-size: 1rem;
}

.leadership-intro {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  border: 1px solid var(--border);
  border-radius: 1.25rem;
  background: linear-gradient(135deg, rgba(0, 150, 64, 0.11), rgba(255, 255, 255, 0.025));
}

.intro-icon,
.card-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 1rem;
}

.intro-icon {
  width: 3.25rem;
  height: 3.25rem;
  color: #7ee5a6;
  background: rgba(0, 150, 64, 0.16);
}

.intro-icon .v-icon,
.card-icon .v-icon {
  color: currentColor;
}

.eyebrow,
.card-copy > span {
  color: #7ee5a6;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.leadership-intro h2 {
  margin: 0.1875rem 0 0.375rem;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1.2;
}

.leadership-intro p,
.card-copy p {
  margin: 0;
  color: #c7c7cb;
  font-size: 1rem;
  line-height: 1.55;
}

.leadership-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.leadership-card {
  display: flex;
  min-width: 0;
  min-height: 28rem;
  flex-direction: column;
  padding: 1.25rem;
  border: 1px solid var(--border);
  border-radius: 1.25rem;
  background: radial-gradient(circle at 100% 0, var(--accent-bg), transparent 13rem), rgba(255, 255, 255, 0.035);
}

.card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.card-icon {
  width: 3rem;
  height: 3rem;
  color: var(--accent);
  background: var(--accent-bg);
}

.card-badge {
  padding: 0.375rem 0.625rem;
  border-radius: 999px;
  color: var(--accent);
  background: var(--accent-bg);
  font-size: 0.75rem;
  font-weight: 750;
}

.card-copy {
  margin-top: 1.25rem;
}

.card-copy > span {
  color: var(--accent);
}

.card-copy h3 {
  margin: 0.25rem 0 0.625rem;
  color: #fff;
  font-size: 1.25rem;
  line-height: 1.25;
}

.leadership-card ul {
  display: grid;
  gap: 0.625rem;
  margin: 1.25rem 0;
  padding: 0;
  color: #d4d4d8;
  list-style: none;
}

.leadership-card li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.45;
}

.leadership-card li .v-icon {
  margin-top: 0.0625rem;
  color: var(--accent);
  font-size: 1.125rem;
}

.area-action {
  min-height: 2.875rem !important;
  margin-top: auto;
  border-radius: 0.875rem !important;
  color: #fff !important;
  background: var(--accent-bg) !important;
  font-size: 0.875rem !important;
  font-weight: 750;
  letter-spacing: 0;
  text-decoration: none !important;
  text-transform: none;
}

.area-action:hover,
.area-action:focus,
.area-action:active {
  text-decoration: none !important;
}

@media (max-width: 68rem) {
  .leadership-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 43rem) {
  .leadership-intro {
    padding: 1rem;
  }

  .leadership-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .leadership-card {
    min-height: 0;
    padding: 1rem;
  }
}
</style>
